The array of components in the order they are presented to the candidate.
